export default __webpack_public_path__ + "static/media/tidy3d_logo.038727a2.svg";